import { usePlanoForm } from './Context';

export const PlanoFormHeader = () => {
    const { plano, setPlano, clientId, setClientId, clients } = usePlanoForm();

    return (
        <div>
            <div className="flex flex-wrap justify-center breadcrumbs">
                <ul className="flex flex-wrap gap-2 justify-center">
                    <li className="animate__animated animate__fadeIn">
                        <button
                            className="btn btn-sm p-1 hover:animate__animated hover:animate__bounce"
                            onClick={() => {
                                setPlano(null);
                            }}
                        >
                            {
                                !!plano?._id ? plano.name : 'Selecione um plano'
                            }
                        </button>
                    </li>

                    {
                        !!plano?._id && (
                            <li className="animate__animated animate__fadeIn">
                                <button
                                    className="btn btn-sm p-1 hover:animate__animated hover:animate__bounce"
                                    onClick={() => {
                                        setClientId('');
                                    }}
                                >
                                    {
                                        !!clientId ? clients?.find((e: any) => e.value === clientId)?.label : 'Selecione um cliente'
                                    }
                                </button>
                            </li>
                        )
                    }
                </ul>
            </div>
        </div>
    );
};
